module.exports = __webpack_public_path__ + "img/trans-location-icon-hover.173cc173.svg";